import React from 'react';

/**
 * Champ de sélection (liste déroulante)
 * @param {Array} options - Tableau de { valeur, label }
 */
function ChampSelect({ label, valeur, onChange, options, pleineLargeur, nom }) {
  return (
    <div className={`champ${pleineLargeur ? ' champ--pleine-largeur' : ''}`}>
      {label && <label className="champ__label">{label}</label>}
      <select
        className="champ__select"
        value={valeur}
        onChange={(e) => onChange(nom || label, e.target.value)}
      >
        
        {options.map((opt) => (
          <option key={opt.valeur} value={opt.valeur}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default ChampSelect;
